/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Import_Results_TitleInputs */

const en_preset_manager_import_results_title = /** @type {(inputs: Preset_Manager_Import_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Results`)
};

const fr_preset_manager_import_results_title = /** @type {(inputs: Preset_Manager_Import_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultats de l'importation`)
};

const de_preset_manager_import_results_title = /** @type {(inputs: Preset_Manager_Import_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importergebnisse`)
};

const it_preset_manager_import_results_title = /** @type {(inputs: Preset_Manager_Import_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa risultati`)
};

const ru_preset_manager_import_results_title = /** @type {(inputs: Preset_Manager_Import_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты импорта`)
};

const es_preset_manager_import_results_title = /** @type {(inputs: Preset_Manager_Import_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar resultados`)
};

const zh_cn2_preset_manager_import_results_title = /** @type {(inputs: Preset_Manager_Import_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入结果`)
};

const ja_preset_manager_import_results_title = /** @type {(inputs: Preset_Manager_Import_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポート結果`)
};

const hi_preset_manager_import_results_title = /** @type {(inputs: Preset_Manager_Import_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिणाम आयात करें`)
};

const pt_pt2_preset_manager_import_results_title = /** @type {(inputs: Preset_Manager_Import_Results_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados da Importação`)
};

/**
* | output |
* | --- |
* | "Import Results" |
*
* @param {Preset_Manager_Import_Results_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_results_title = /** @type {((inputs?: Preset_Manager_Import_Results_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_Results_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_import_results_title(inputs)
	if (locale === "de") return de_preset_manager_import_results_title(inputs)
	if (locale === "it") return it_preset_manager_import_results_title(inputs)
	if (locale === "ru") return ru_preset_manager_import_results_title(inputs)
	if (locale === "es") return es_preset_manager_import_results_title(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_import_results_title(inputs)
	if (locale === "ja") return ja_preset_manager_import_results_title(inputs)
	if (locale === "hi") return hi_preset_manager_import_results_title(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_import_results_title(inputs)
	return en_preset_manager_import_results_title(inputs)
});